<template>
  <div class="container">
    <div class="title" style="color:orange;">
      ————<span>{{itemTitle}}</span>————
    </div>
    <div class="content">
      <ul class="item-box" v-for="(data,page) in pageData" :key="page">
        <li class="item"
          v-for="(item,index) in data" :key="page+'_'+index"  
          @click="itemClick(item)"
        >
          <!-- {{page+'/'+index}} -->
          <span class="node start">{{item.StartNodeName}}</span><br/>
          <span class="node"> {{'->'+item.ArrivalNodeName+'<-'}} </span>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
import { Col, Row } from 'vant'

export default {
  name: "itemsPager",
  components: {
    [Col.name]: Col,
    [Row.name]: Row
  },
  props: {
    itemTitle:String,
    items: Array
  },
  computed: {
	
			//历史数据分页
			pageData() {
        
				let totalItems=this.items
				let pageArray = new Array()
				let pageSize = 3

				if (totalItems&&totalItems.length>0) {
					let itemdata = totalItems
					//数据分页
					itemdata=itemdata.reverse()
					itemdata.forEach((item, index) => {
  
							let page = Math.ceil((index + 1) / pageSize)-1
							let pageItem = pageArray[page]

							if (pageItem) {
								pageItem.push(item)
							} else {
								pageArray[page] = [item]
							}
						})
				}

				return pageArray

			}
			
		},
  methods: {
    itemClick(item) {
      this.$emit("itemClick", item);
    }
  }
};
</script>


<style scoped lang="less">


.container{
  width: 95%;
  margin: 10px auto 5px;
  padding: 5px 0px;
    background-color: #fafafa;

}

.title {
  font-size:10px;
  line-height: 30px;
  text-align: center;
  color: #999;
  margin-top: 10px;
  margin: 0 10px;
}

.content {
    background-color: #fafafa;
    margin-bottom: 15px;
    padding: 2px 0px 0px 5px;
    padding-bottom: 10px;
    box-sizing:border-box;
    border-radius: 2px;
    text-align: center;
    margin: 0 auto;
    width: 100%;   
}

.item-box{
  width: 100%;
  box-sizing:border-box;
  display: flex;
  flex-direction:row;
  flex-wrap:nowrap;
  justify-content: start  ; 
  align-items:stretch;
}

.item {
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  color: #7a7676;
  background: #f3eded;
  box-sizing:border-box;
  border-left: 3px solid orange;
  padding: 5px 5px;
  margin-left: 2px;
  margin-top: 5px;
  min-width: 100px;
  max-width: 120px;
  overflow: hidden;

  .node{
    font-size:13px;
    height: 20px;
    line-height: 20px;
    word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		text-align: center;
		text-overflow: ellipsis;    
  }

  .node.start{
    width:50px ;
    border: 0px solid blue;
  }

  
}

.clear {
  clear: both;
  margin-bottom: 10px;
}
</style>
